// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2C36o","upload":"Small_upload__5UiLs","imageWrap":"Small_imageWrap__2SGKu","removeBtn":"Small_removeBtn__27m5u"};